import React from 'react';

const withPersonalSurveyDisplayName = <T,>(WC: React.ComponentType<T>): React.ComponentType<T> => {
  // TODO fix this (matt.8.23.23)
  // @ts-ignore
  const MyComp = (props: T) => <WC {...props} />;
  MyComp.displayName = 'PersonalSurvey';
  return MyComp;
};

export default withPersonalSurveyDisplayName;
